export default __webpack_public_path__ + "static/media/02.5f85d8be.jpg";